module.exports = __webpack_public_path__ + "img/square-sharp-light.036187c9.svg";